import React, { useEffect, useState } from 'react'
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { addNewProduct, getGroupEntryByGuid, getProductTypeguid, getUnitguid } from '../../../../services/MasterApiServices';
import { ProductClass } from '../../../../core/json/ProductClass';
import SectionWiseProductDetail from '../../../../core/json/SectionWiseProductDetail';
import { SectionClass } from '../../../../core/json/SectionClass';
import { setproductData } from '../../../../redux/productData';
import toast from 'react-hot-toast';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { ComboProductDetail } from '../../../../core/json/ComboProductDetail';
import {
  Trash2
} from "feather-icons-react/build/IconComponents";
import axios from 'axios';

const AddProductProfile = ({ register, watch, control, errors, productName, setValue}) => {


  const dispatch = useDispatch()
  const animatedComponents = makeAnimated();
  const { branch } = useSelector((state) => state.branchlist);
  const [products, setproducts] = useState([])
  const { deliveyTypes, unitList, taxList, groupList, productList, categoryList } = useSelector((state) => state.usersetting);
  // Get user from redux
  const { userId } = useSelector((state) => state.userauth)

  const API_KEY = process.env.REACT_APP_TRANSLATION_API_KEY;

  const languages = [
    { code: "ar", name: "Arabic" },
    // { code: "hi", name: "Hindi" },
    // { code: "ml", name: "Malayalam" },
  ];

    const handleTranslation = async (targetLanguage) => {
      if (!productName) {
        toast.error("Please enter a product name to translate.");
        return;
      }
  
      const url = `https://translation.googleapis.com/language/translate/v2?key=${API_KEY}`;
  
      try {
        const response = await axios.post(url, {
          q: productName,
          target: targetLanguage,},
      {
        // By setting `requireheader: false`, the global headers will be blocked
        requireheader: false,
      }
    );
  
      const translatedText = response.data.data.translations[0].translatedText;
      setValue("ShortName", translatedText); // Update Arabic Description
      toast.success("Translation completed!");
    } catch (error) {
      console.error("Translation error:", error.response?.data || error.message);
      toast.error("Error translating text");
    }
  };
  

  const comboType = deliveyTypes?.find(type => type.name === 'Combo'); // Find Combo type
  const COMBO_TYPE_ID = comboType?.guid; // Get Combo type GUID

  useEffect(() => {
    const newlist = productList?.map(e => ({
      label: e.name,
      value: e.guid
    }))
    setproducts(newlist)
  }, [])
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'items',
  });

  const [selectedItem, setSelectedItem] = useState('');


  const handleAddMore = () => {
    append({ name: '', maxItems: '', comments: '' });
  };

  return (
    <div>
      <div className="modal-body custom-modal-body">
        <div className="branch-tabs col-12 align-items-center justify-content-between">

        </div>

        <div className="row">
          <div className="col-md-6 col-sm-12">
            <div className="input-blocks d-flex align-items-center">
              <label htmlFor="Name"
                className="me-2"
                style={{ width: "100px" }}>Name<span className="text-danger">*</span></label>
              <input type="text" placeholder="Name"  {...register("Description1", { required: "Name is required" })} />
              {errors?.Description1 && (
                <span className="error text-danger text-sm">{errors.Description1.message}</span>
              )}
            </div>
          </div>


          <div className="col-md-6 col-sm-12">
              <div className="input-blocks d-flex align-items-center">
                <label htmlFor="Short Name"
                       className="me-4"
                    style={{ width: "100px" }}>Other Language</label>
                <input type="text" placeholder=""   className="me-1 form-control"
                // defaultValue={ShortDescription}
                value={watch("ShortName")}
                  {...register("ShortName")}
         //shortname
                  />
                     {languages.map((lang) => (
                    <button
                      key={lang.code}
                      type="button"
                      className="btn btn-primary"
                      onClick={() => handleTranslation(lang.code)}
                    >
                      {lang.name}
                    </button>
                  ))}
              </div>
            </div>

            {/* <div className="col-md-6 col-sm-12">
              <div className="input-blocks d-flex align-items-center">
              <label className="col-form-label">Translate to</label>
              <div className="col-12 ms-3">
              {languages.map((lang) => (
                    <button
                      key={lang.code}
                      type="button"
                      className="btn btn-primary me-2"
                      onClick={() => handleTranslation(lang.code)}
                    >
                      {lang.name}
                    </button>
                  ))}
                     </div>
              </div>
             
            </div> */}

          {/* <div className="col-md-6 col-sm-12">
            <div className="input-blocks d-flex align-items-center">
              <label htmlFor="Short Name"
                className="me-2"
                style={{ width: "100px" }}>Short Name<span className="text-danger">*</span></label>
              <input type="text" placeholder="Short Name"  {...register("ShortName", { required: "Short Name is required" })} />
              <textarea
        id="ShortName"
        placeholder="Short Name"
        
        rows={3}
        {...register("ShortName", { required: "Short Name is required" })}
      />
              {errors?.ShortName && (
                <span className="error text-danger text-sm">{errors.ShortName.message}</span>
              )}
            </div>
          </div> */}


          <div className="col-md-6 col-sm-12">
            <div className="input-blocks d-flex align-items-center">
              <label htmlFor="Code"
                className="me-2"
                style={{ width: "100px" }}>
                Code<span className="text-danger">*</span></label>
              <input type="text" placeholder="Code"  {...register("ProdCode", { required: "Code is required" })} />
              {errors?.ProdCode && (
                <span className="error text-danger text-sm">{errors.ProdCode.message}</span>
              )}
            </div>
          </div>

          {/* <div className="col-md-6 col-sm-12">
            <div className="input-blocks d-flex align-items-center">
              <label
                htmlFor="barCode"
                className="me-2"
                style={{ width: "100px" }} // Adjust width as needed
              >
                Stock Type<span className="text-danger">*</span>
              </label>

              <input
                // id="barCode"
                type="number"
                placeholder=""
                className={"form-control"}
                {...register("StockTypeID")}
              />
              {errors?.barCode && (
                <span className="error text-danger text-sm">{errors.barCode.message}</span>
              )}
            </div>
          </div> */}


          <div className="col-md-6 col-sm-12">
  <div className="input-blocks d-flex align-items-center">
    <label
      htmlFor="StockTypeID"
      className="me-2"
      style={{ width: "100px" }} // Adjust width as needed
    >
      Stock Type<span className="text-danger">*</span>
    </label>

    <select
   
      id="StockTypeID"
      className="form-control"
      {...register("StockTypeID", { required: "Stock Type is required" })}
      defaultValue=""
    >
      <option value="" disabled>Select Stock Type</option>
      <option value="1">Stock</option>
      <option value="2">Non-Stock</option>
      <option value="3">Discontinued</option>
    </select>

    {errors?.StockTypeID && (
      <span className="error text-danger text-sm">{errors.StockTypeID.message}</span>
    )}
  </div>
</div>




          <div className="col-md-6 col-sm-12">
            <div className="input-blocks d-flex align-items-center">
              <label htmlFor="Category"
                className="me-2"
                style={{ width: "100px" }} >Category<span className="text-danger">*</span></label>
              <select
                {...register("category", { required: "Category is required" })}

                className=" form-control"

              >
                <option value="" disabled>
                  Select Category
                </option>
                {categoryList?.map((category) => (
                  <option key={category.guid} value={category.guid}>
                    {category.name}
                  </option>
                ))}
              </select>
              {errors?.category && (
                <span className="error text-danger text-sm">{errors.category.message}</span>
              )}
            </div>
          </div>

          <div className="col-md-6 col-sm-12">
            <div className="input-blocks d-flex align-items-center">
              <label htmlFor="Item Type"
                className="me-2"
                style={{ width: "100px" }}>Item Type<span className="text-danger">*</span></label>
              <select
                {...register("type", { required: "Item Type is required" })}

                className=" form-control"

              >
                <option value="" disabled>
                  Select Type
                </option>
                {deliveyTypes?.map((type) => (
                  <option key={type.guid} value={type.guid}>
                    {type.name}
                  </option>
                ))}
              </select>
              {errors?.type && (
                <span className="error text-danger text-sm">{errors.type.message}</span>
              )}
            </div>
          </div>
          {watch().type === COMBO_TYPE_ID &&
            <>
              {fields?.map((item, index) => (
                <div className="row border border-warning p-3" key={index}>

                  <div className="col-12">
                    <div className="input-blocks">
                      <label className="form-label">Select Combo Products</label>
                      <Controller
                        {...register(`items[${index}].name`,
                          { required: watch().type === COMBO_TYPE_ID }
                        )}
                        name={`items[${index}].name`}
                        control={control}
                        render={({ field }) => (
                          <Select
                            closeMenuOnSelect={false}
                            {...field}
                            isMulti
                            components={animatedComponents}
                            placeholder="Select Combo Products"

                            options={products}
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="input-blocks">
                      <label className="form-label">Enter maximum number of items</label>
                      <input
                        type="number"
                        min={0}
                        id={`items[${index}].maxItems`}
                        {...register(`items[${index}].maxItems`, { required: watch().type === COMBO_TYPE_ID })}
                        className="form-control"
                        placeholder='Enter maximum number of items'
                      />
                    </div>
                  </div>
                  {index > 0 &&
                    <div className="col-md-3 col-sm-6">
                      <button
                        type="button"
                        onClick={() => remove(index)}
                        className="btn btn-danger"
                        style={{ height: "38px" }}
                      >
                        <Trash2 />
                      </button>

                    </div>
                  }

                </div>
              ))}
              <div className="text-end mt-3">
                <button type="button" onClick={handleAddMore} className="btn btn-primary">
                  Add More Side Choice
                </button>
              </div>


            </>
          } {/* Conditionally render AddCombo */}


        </div>
        <div className="row">
          <div className="col-md-6 col-sm-12">
            <div className="input-blocks d-flex align-items-center">
              <label htmlFor="Group"
                className="me-2"
                style={{ width: "100px" }}
              >Group<span className="text-danger">*</span></label>
              <select
                {...register("group", { required: "Group is required" })}

                className=" form-control"

              >
                <option value="" disabled>
                  Select Group
                </option>
                {groupList?.map((group) => (
                  <option key={group.guid} value={group.guid}>
                    {group.name}
                  </option>
                ))}
              </select>
              {errors?.group && (
                <span className="error text-danger text-sm">{errors.group.message}</span>
              )}
            </div>
          </div>
          <div className="col-md-6 col-sm-12">
            <div className="input-blocks d-flex align-items-center">
              <label htmlFor="Base Unit"
                className="me-2"
                style={{ width: "100px" }}>Base Unit<span className="text-danger">*</span></label>
              <select
                {...register("unit", { required: "Base Unit is required" })}

                className=" form-control"
              >
                <option value="" disabled>
                  Select Unit
                </option>
                {unitList && unitList?.map((unit) => (
                  <option key={unit.guid} value={unit.guid}>
                    {unit.name}
                  </option>
                ))}
              </select>
              {errors?.unit && (
                <span className="error text-danger text-sm">{errors.unit.message}</span>
              )}
            </div>
          </div>
          <div>
          </div>
          <div className="col-md-6 col-sm-12">
            <div className="input-blocks d-flex align-items-center">
              <label htmlFor="Short Name"
                className="me-2"
                style={{ width: "100px" }}>Cost</label>
              <input
                type="number" 
                placeholder=""
                min={0}
                className='form-control'
                defaultValue={0}
                {...register("AvgCost", { required: "cost is required" })}
              />

            </div>
          </div>
          <div className="col-md-6 col-sm-12">
            <div className="input-blocks d-flex align-items-center">
              <label htmlFor="Short Name"
              
                className="me-2"
                style={{ width: "100px" }}>Tax<span className="text-danger">*</span></label>
              <select
              
                {...register("tax", { required: "Tax is required" })}

                className=" form-control"
                defaultValue=""
              >
                <option value="" disabled>
                  Select Tax
                </option>
                {taxList?.map((tax) => (
                  <option key={tax.guid} value={tax.guid}>
                    {tax.name}

                  </option>
                ))}
              </select>
              {errors?.tax && (
                <span className="error text-danger text-sm">{errors.tax.message}</span>
              )}
            </div>
          </div>
          <div className="col-md-6 col-sm-12">
            <div className="input-blocks d-flex align-items-center">
              <label htmlFor="Short Name"
                className="me-2"
                style={{ width: "100px" }}>Retail Price</label>
              <input type="number" 
              placeholder=""
              min={0}
              step="0.01"
              className='form-control'
                defaultValue={0}
                {...register("RetailRate")} 
              />

            </div>
          </div>

          <div className="col-md-6 col-sm-12">
            <div className="input-blocks d-flex align-items-center">
              <label htmlFor="Name"
                className="me-2"
                style={{ width: "100px" }}>Wholesale Price</label>
              <input type="number" 
              placeholder=""
              min={0}
              step="0.01"
              className='form-control'
                defaultValue={0}
                {...register("WSRate")}
              />

            </div>
          </div>

          <div className="row">
<div className="col-md-6 col-sm-12">
<div className="input-blocks d-flex align-items-center">
  <input type="checkbox" {...register("isSalesTaxIncludedInPrice")} />
  <label className="ms-2 mb-1">Tax Included In Sales Price</label>
</div>
</div>
{/* <div className="col-md-6 col-sm-12">
<div className="input-blocks d-flex align-items-center">
  <input type="checkbox" {...register("otherDescription.isPurchaseTaxIncludedInPrice")} />
  <label className="ms-2 mb-1">Purchase Rate</label>
</div>
</div> */}
</div>
          <div className="col-md-6 col-sm-12">
            <div className="input-blocks d-flex align-items-center">
              <label htmlFor="Name"
                //  className="me-4"
                style={{ width: "100px", marginRight: "34px" }}>UBC<span className="text-danger">*</span></label>
              <input type="text" placeholder=""
                {...register("Ubc")}
              />

              <div className="d-flex justify-content-end m-2">
                <button
                  type="button"
                  className="btn btn-sm btn-primary me-1">
                  Generate
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-danger">
                  Print
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-12">
            <div className="input-blocks d-flex align-items-center">
              <label htmlFor="Name"
                //  className="me-4"
                style={{ width: "100px", marginRight: "34px" }}>SBC<span className="text-danger">*</span></label>
              <input type="text" placeholder="" style={{ width: "" }}
                {...register("Sbc")}
              />
              <div className="d-flex justify-content-end m-2">
                <button
                  type="button"
                  className="btn btn-sm btn-primary me-1">
                  Generate
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-danger">
                  Print
                </button>
              </div>
            </div>
          </div>




          {/* <div className="col-md-6 col-sm-12">
               <div className="input-blocks d-flex align-items-center">
                 <label  htmlFor="Other Description"
    className="me-2"
    style={{ width: "100px" }}>Other Description</label>
                <input
                  type="text"
                  placeholder="Other Description"  {...register("otherDescription")}
                />
              </div>
            </div> */}
          {/* <div className="col-md-6 col-sm-12">
               <div className="input-blocks mt-4 d-flex">
               
                <input
                  type="checkbox"
                 
                  defaultChecked
                  placeholder="Other Description"  {...register("isActive")}
                />
                <label>Is Active</label>
                 
              </div>
            </div> */}
        </div>
      </div>
    </div>
  )
}
export default AddProductProfile

